import axios from "axios";
import React, { Component } from "react";
import { withRouter } from "react-router";

import {
  FormGroup,
  Row,
  Col,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormFeedback,
  Collapse
} from "reactstrap";
import withReactContent from "sweetalert2-react-content";
import api from "../../../utils/axiosApi";
import { Toast } from "../../../utils/sweetalert";
import { emailSchema, nameSchema, passwordSchema } from "../../../utils/validateForm";
import ImageUploader from "../../components/imageUpload";


class Forms extends Component {
  constructor(props) {
    super(props) 
    this.state = {
      nameAgency : '',
      legalName : '',
      email : '',
      emailPublico : '',
      urlId:'',

      nombreBancario:'',
      idBancario:'',
      direccion:'',
      telfCel:'',
      whatsapp:false,
      telfFijo:'',
      level: 'agency',
      
      banco:'',
      cuenta:'',
      cuentaType:'',
      cityAssociate:'',

      cities:[],
      location:'',
      isOpen:false,

      image:undefined,

      errors : {
        name : false,
        email : false,
        password : false,
        newPassword: false,
      }
    }
  }
  handleSubmit = async (e) =>{
    e.preventDefault()
    const {
      nameAgency ,
      legalName ,
      email ,
      emailPublico,

      nombreBancario,
      idBancario,
      direccion,
      telfCel,
      telfFijo,
      level,
      
      banco,
      cuenta,
      cuentaType,
      cityAssociate,
      whatsapp,
      urlId
    } = this.state

    const dataToSend= {
      level,
      name:nameAgency,
      legalName,
      email,
      publicEmail : emailPublico,
      direccion,
      telfFijo,
      telfCel,
      whatsapp,
      city:cityAssociate,
      bankData : {

        nameUser : nombreBancario,
        idBankUser: idBancario,
        bank :banco,
        account : cuenta,
        typeAccount: cuentaType,
      }

    }
        const emailValidation = emailSchema.validate(dataToSend.email);
        const publicEmailValidation = emailSchema.validate(dataToSend.publicEmail);
        const nameValidation = nameSchema.validate(dataToSend.name)
        let newStateError = {...this.state.errors}
        if (emailValidation.error) {
            
            newStateError = {...newStateError, email: '*Email No Valido'}
        }
        if (nameValidation.error) {
            newStateError = {...newStateError, name: '*Password No Valida'}
        }
        this.setState({errors: newStateError})
         if(emailValidation.error || publicEmailValidation.error|| nameValidation.error) {return}
         try {
          /*await api.post(`/user/signup`, {
            name: this.state.name,
            email: this.state.email,
            password: this.state.password,
            repassword: this.state.repassword,
            level: this.state.level,
            remenber: false
          })*/debugger
          const resp = await api.get(`/Email/CreatepassAgency?email=${email}&len=${'es'}`)
          
          const formData = new FormData()
          formData.append('file', this.state.image)
          formData.append('upload_preset', 'tripendar')
          const cloudinaryKey = process.env.REACT_APP_CLOUDINARY_KEY || 'drdcye5c'//tripendar/y7supfvk80sxyhyjornj
          
          var respCloud = undefined
          var urlImg = ''
          var idImg = ''
          if(this.state.image) {
            respCloud = await axios.post(`https://api.cloudinary.com/v1_1/${cloudinaryKey}/image/upload`, formData)
            urlImg = respCloud.data.secure_url
            idImg = respCloud.data.public_id
          }
          debugger
          const user =await api.post(`/user/signup`, {
            name: dataToSend.name,
            lastName:'',
            email: dataToSend.email,
            password: resp.data.data.codigo,
            repassword: resp.data.data.codigo,
            level: dataToSend.level,
            remenber: false,

            
            direccion: dataToSend.direccion,
            telfFijo: dataToSend.telfFijo,
            telfCel : dataToSend.telfCel,
            whatsapp: dataToSend.whatsapp,
          })
          /*
          const agency =*/await api.post(`/influencer/`, {
            userId: user.data.data.id,
            nameAgency :dataToSend.name,
            legalNameAgency: dataToSend.legalName,
            emailPublico : dataToSend.publicEmail,
            idImg :idImg,
            urlImg:urlImg,
            urlId:urlId,
          })


          const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '1.5rem'}}>Admin creado Exitosamente</p>,
                icon: 'success',
                
            })
         } catch (error) {
           //console.log(error)
           const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '1.5rem'}}>algo salio Mal...</p>,
                icon: 'error',
                
            })
         }
    
  }
  handleChange = (e) => {
    const value = e.target.value.toLowerCase()
    this.setState({[e.target.name]: value})
  }
  handleChangeNoLowercase = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }
  handleChangeCity = async (e) => {
    this.setState({location: e.target.value})
    if(!this.state.disabled) {this.setState({disabled: true})}
    if(e.target.value.length > 3) {
      try {
          this.setState({isOpen: true})
          const resp = await api.get(`/ciudades/getcities?city=${e.target.value}`)
          if(resp.data.query === e.target.value) {
              this.setState({cities: resp.data.data})
          }
      } catch (error) {
        this.setState({isOpen: false})
          //console.log(error)
      }
  }else {
    this.setState({isOpen: false})
  }
    /*
    const arraytag = e.target.value.split(';')
    const newarray = arraytag.map((e) => (e.trim()))
    this.setState({[e.target.name]: newarray })*/
  }
  Handleclick = (place, _id) => {
    this.setState({location: place, isOpen: false, disabled:false, cityAssociate: _id})
  }
  handleValidateEmail =(e) =>{
    const validation = emailSchema.validate(this.state.email)
        if(validation.error) {
            this.setState({errors: {...this.state.errors, email: true}})
        } else {
            this.setState({errors: {...this.state.errors, email: false}})
        }
  }
  handleValidateName =(e) =>{
    const validation = nameSchema.validate(this.state.nameAgency)
        if(validation.error) {
            this.setState({errors: {...this.state.errors, name: true}})
        } else {
            this.setState({errors: {...this.state.errors, name: false}})
        }
  }
  handleValidateurlId = async (e) =>{
    try {
      debugger
      const msgCalendar = await api.get(`/agencias/getAgency/${this.state.urlId}`)
      if(msgCalendar.data.data?._id) {
        this.setState({errors: {...this.state.errors, urlId: true}})
      } else (
        this.setState({errors: {...this.state.errors, urlId: false}})

      )
    } catch (error) {
      this.setState({errors: {...this.state.errors, urlId: true}})
    }
    const validation = nameSchema.validate(this.state.nameAgency)
        if(validation.error) {
            this.setState({errors: {...this.state.errors, name: true}})
        } else {
            this.setState({errors: {...this.state.errors, name: false}})
        }
  }
  handleValidatePassword =(e) =>{
    const validation = passwordSchema.validate(this.state.password)
        if(validation.error || this.state.password !== this.state.repassword) {
            this.setState({errors: {...this.state.errors, password: true}})
        } else {
            this.setState({errors: {...this.state.errors, password: false}})
        }
  }
  handleChangeImg = (file) => {
    this.setState({image: file})
  }
  render() {
    return (
      <>
      <div className="content">
        <Row>
        <Col md='12'>
          <CardHeader>
                <CardTitle tag="h4">Crear Influencer</CardTitle>
                </CardHeader>
        </Col>
          <Col md="12">
            <Card>
                <CardHeader>
                <CardTitle tag="h4">Datos de la agencia</CardTitle>
                </CardHeader>
            <CardBody>
              <form>
                <FormGroup>
                  <Label for="nameAgency">Nombre Del Influencer</Label>
                  <Input
                    onChange={this.handleChange}
                    onBlur={this.handleValidateName}
                    invalid={this.state.errors.name}
                    type="text"
                    name="nameAgency"
                    id="nameAgency"
                    placeholder="Introduzca el nombre"
                  />
                  <FormFeedback>El nombre no es Valido</FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="legalName">Nombre Legal Del Influencer</Label>
                  <Input
                    onChange={this.handleChange}
                    onBlur={this.handleValidateName}
                    
                    type="text"
                    name="legalName"
                    id="legalName"
                    placeholder="Introduzca el nombre"
                  />
                  <FormFeedback>El nombre no es Valido</FormFeedback>
                </FormGroup>
                
                
                <Row>
                          <Col className="pr-md-1" md="5">
                          <FormGroup>
                            <Label for="email">Correo</Label>
                            <Input
                              onChange={this.handleChange}
                              onBlur={this.handleValidateEmail}
                              invalid={this.state.errors.email}
                              type="email"
                              name="email"
                              id="email"
                              placeholder="Introduzca el Email"
                            />
                            <FormFeedback>El correo no es Valido</FormFeedback>
                          </FormGroup>
                          </Col>
                          <Col className="pl-md-1" md="5">
                          <FormGroup>
                            <Label for="emailPublico">Correo publico</Label>
                            <Input
                              onChange={this.handleChange}
                              type="email"
                              name="emailPublico"
                              id="emailPublico"
                              placeholder="Introduzca el correo de contacto"
                            />
                            <FormFeedback>El correo no es Valido</FormFeedback>
                          </FormGroup>
                          </Col>
                          <Col className="pl-md-1" md="5">
                          <FormGroup>
                            <Label for="urlId">Cual quieres que sea tu url?</Label>
                            <Label for="urlId">seria algo como: {`/bussiness/${this.state.urlId}`}</Label>
                            <Input
                              onChange={this.handleChange}
                              onBlur={this.handleValidateurlId}
                              invalid={this.state.errors.urlId}
                              type="text"
                              name="urlId"
                              id="urlId"
                              placeholder="Introduzca el id del url"
                            />
                            <FormFeedback>El URLID ya esta siendo utilizado</FormFeedback>
                          </FormGroup>
                          </Col>
                          {/* <Col className="pl-md-1" md="2">
                          <FormGroup>
                            <Label for="level">Tipo de cuenta</Label>
                            <Input 
                              onChange={this.handleChange} 
                              className='p-0'
                              value={this.state.level}
                              type="select" 
                              name="level" 
                              id="level">
                                <option disabled>Seleccione un tipo</option>
                                <option value='hotel'>Hotel</option>
                                <option value='agency'>Agencia</option>
                              </Input>
                          </FormGroup>
                          </Col> */}
                          
                        </Row>
                <Row>
                          <Col className="pr-md-1" md="4">
                          <FormGroup>
                            <Label for="password">Direccion</Label>
                            <Input
                              onChange={this.handleChange}
                              onBlur={this.handleChange}
                              type="direccion"
                              name="direccion"
                              id="exampleEmail"
                              placeholder="Direccion"
                            />
                            <FormFeedback>la Direccion no es Valida</FormFeedback>
                          </FormGroup>
                          </Col>
                          <Col className="pl-md-1" md="3">
                          <FormGroup >
                            <Label for="telfFijo">Telefono fijo</Label>
                            <Input
                              onChange={this.handleChangeNoLowercase}
                              type="text"
                              name="telfFijo"
                              id="telfFijo"
                              placeholder="Telefono Fijo"
                            />
                          </FormGroup>
                          </Col>
                          <Col className="pl-md-1" md="3">
                          <FormGroup >
                            <Label for="telfCel">Telefono Celular</Label>
                            <Input
                              onChange={this.handleChangeNoLowercase}
                              type="text"
                              name="telfCel"
                              id="telfCel"
                              placeholder="Telefono Celular"
                            />
                          </FormGroup>
                          </Col>
                          <Col className="pl-md-1 d-flex justify-content-center align-items-center" md="2">
                          <FormGroup >
                            <Input
                            className=" mt-1"
                              type="checkbox"
                              checked={this.state.whatsapp}
                              onChange={(e) => {
                                this.setState({whatsapp:e.target.checked})}}
                            />
                            <Label className="ml-3" for="telfCel">Poseé whatsapp?</Label>

                          </FormGroup>
                          </Col>
                          
                        </Row>
            {/* <FormGroup>
            <Label for="location">Ciudad</Label>
            <Input
              onChange={this.handleChangeCity}
              value={this.state.location}
              invalid= {this.state.errors.location}
              autoComplete='off'
              type="search"
              name="location"
              id="location"
              placeholder="Seleccione una ubicacion de las posibles opciones"
            />
              <FormFeedback> la ciudad no es Valida</FormFeedback>
            <Collapse isOpen={this.state.isOpen}>
            <Card>
                <CardBody className='p-0'>
                <ul style={{zIndex: 300}} className='optionsSearch'> 
                    {(this.state.location.length > 3) && this.state.cities.map(e => {
                        const place = `${e.city}, ${e.state}, ${e.country}`
                        return (
                        <li onClick={() => {this.Handleclick(place, e._id)}}>{place}</li>
                    )})}
                </ul>
                </CardBody>
              </Card>
            </Collapse>
          </FormGroup> */}
                
          <ImageUploader titleImg={this.state.image} handleChangeImg={this.handleChangeImg} />
          
              </form>
            </CardBody>
          </Card>
        </Col>
        {/* <Col md="12">
            <Card>
                <CardHeader>
                <CardTitle tag="h4">Datos Bancarios</CardTitle>
                </CardHeader>
            <CardBody>
                <FormGroup>
                  <Label for="banco">Nombre Del banco</Label>
                  <Input
                    onChange={this.handleChange}
                    type="text"
                    name="banco"
                    id="banco"
                    placeholder="Introduzca el nombre del banco"
                  />
                  <FormFeedback>El nombre no es Valido</FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="nombreBancario">Nombre Del Titular</Label>
                  <Input
                    onChange={this.handleChange}
                    type="text"
                    name="nombreBancario"
                    id="nombreBancario"
                    placeholder="Introduzca el nombre"
                  />
                  <FormFeedback>El nombre no es Valido</FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="idBancario">Numero de Identificacion</Label>
                  <Input
                    onChange={this.handleChange}
                    type="text"
                    name="idBancario"
                    id="idBancario"
                    placeholder="J-12345678"
                  />
                  <FormFeedback>El correo no es Valido</FormFeedback>
                </FormGroup>
                <Row>
                  <Col className="pr-md-1" md="9">
                  <FormGroup>
                    <Label for="cuenta">Numero de la cuenta</Label>
                    <Input
                      onChange={this.handleChange}
                      onBlur={this.handleChange}
                      type="text"
                      name="cuenta"
                      id="cuenta"
                      placeholder="12345-12345-1234567890"
                    />
                    <FormFeedback>la Direccion no es Valida</FormFeedback>
                  </FormGroup>
                  </Col>
                  <Col className="pl-md-1" md="3">
                  <FormGroup >
                    <Label for="cuentaType">Tipo de cuenta</Label>
                    <Input
                      onChange={this.handleChange}
                      type="text"
                      name="cuentaType"
                      id="cuentaType"
                      placeholder="corriente o ahorro"
                    />
                  </FormGroup>
                  </Col>
                  
                </Row>
            </CardBody>
          </Card>
        </Col> */}
          <Button color="primary" type="button" onClick={this.handleSubmit}>
            Crear Influencer
          </Button>
        </Row>
      </div>
    </>
    )
  }
}


export default withRouter(Forms);
